import {createAction} from '@reduxjs/toolkit'
import type {SidePanelContent} from '../reducers/side-panel'

export const openSidePanel = createAction<SidePanelContent>('OPEN_SIDE_PANEL')
export const toggleSidePanel = createAction<SidePanelContent>('TOGGLE_SIDE_PANEL')

export type ToggleSidePanel = typeof toggleSidePanel
export type OpenSidePanel = typeof openSidePanel
